const $ = require("jquery");

const FormSupport = {
  mkto_check_count: 0,
  mkto_check_max: 10,
  mkto_check_delay: 500, // Time between Marketo checks in ms
  init() {
    if ( this.hasHangingForm() ) {
      this.preflight();
    }
  },
  preflight() {
    // Make sure we have Marketo setup before we try to run
    if ( window.MktoForms2 ) {
      this.setup();
    } else {
      if ( this.mkto_check_count++ > this.mkto_check_max ) {
        // Too many checks
        return;
      }
      window.setTimeout(
        () => this.preflight(),
        this.mkto_check_delay
      );
    }
  },
  setup() {
    window.MktoForms2.whenReady( (form) => {
      const $$ = form.getFormElem();
      if ( $$.closest('.js-form-hanging-label').length <= 0 ) {
        // Not a form we care about
        return;
      }
      $$.on( 'change', '.mktoField', event => this.onChange( $(event.target) ) );
      $$.on( 'focus', '.mktoField', event => this.onFocus( $(event.target) ) );
      $$.on( 'blur', '.mktoField', event => this.onBlur( $(event.target) ) );

      // Correctly handle fields with initial values
      $$.find('.mktoField').each( (_, el) => this.onChange( $(el) ) );
    } );
  },
  onChange($field) {
    if ( $field.val() ) {
      $field.parent().addClass('has-value');
    } else {
      $field.parent().removeClass('has-value');
    }
  },
  onFocus($field) {
    $field.parent().addClass('has-focus');
  },
  onBlur($field) {
    $field.parent().removeClass('has-focus');
  },
  hasHangingForm() {
    return $('.js-form-hanging-label').length > 0;
  }
};
$(FormSupport.init.bind(FormSupport));
